import { ANNULMENT_STATUS } from 'data-layer-cr/dist/functions/carPolicies';
import { dateFormats } from 'data-layer-cr/dist/functions/helpers';
import { CarPolicy } from 'data-layer-cr/dist/models';
import { isValid, isWithinInterval } from 'date-fns';

const { dateFromString, addDayToDate } = dateFormats;

export default function hasUpcomingCancellation(
  policy: CarPolicy | undefined,
  targetDate = new Date(),
): boolean {
  if (!policy) {
    return false;
  }
  const startDate = dateFromString(policy.effectiveStartDate);
  const endDate = dateFromString(policy.effectiveEndDate);
  if (!isValid(startDate) || !isValid(endDate)) {
    return false;
  }
  return (
    isWithinInterval(endDate, {
      start: startDate,
      end: addDayToDate(targetDate, 60),
    }) && ANNULMENT_STATUS.includes(policy.policyStatus)
  );
}
